module.exports = __webpack_public_path__ + "static/media/LinkedIn.b311badf.png";